import React from 'react';

import './styles.css';

interface LoadingProps {
  isLoading?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ isLoading = true }) => {
  if (!isLoading) return null;

  return (
    <div className="loadingWrapper">
      <div className="spinner" />
    </div>
  );
};

export default Loading;
